<template lang="pug">
  .module__main
    .module__title Список пользователей
    .module-content__container
      .users-control__block
        el-button.user-add__btn(type="primary" size="mini" @click="openUserAdding()") Добавить пользователя
        el-button.user-add__btn(type="warning" size="mini" @click="openUser2fa()") 2FA
      .table__container
        .table-list__container
          el-table(
            v-loading="isLoading"
            :data="users"
            style="width: 100%; font-size: 12px"
          )
            el-table-column(prop="name" label="Логин" width="160" sortable)
            el-table-column(prop="role" label="Роль" width="100" sortable)
              template(v-slot:default="scope")
                span {{ roles[scope.row.role] || scope.row.role }}
            el-table-column(label="Активен" width="100")
              template(v-slot:default="scope")
                .user-active-change__btn(
                  @click="changeUserActiveStatus(scope.row)"
                  :class="scope.row.active ? 'active' : 'inactive'"
                )
                  i.el-icon-check(v-if="scope.row.active")
                  i.el-icon-close(v-else)
            el-table-column(label="Разрешенные IP" width="200")
              template(v-slot:default="scope")
                .allowed-ips__container
                  .allowed-ip__container(v-for="ip in scope.row.allowed_ips" :key="`allowed-ip-${ip}`")
                    span {{ ip }}
                    i.el-icon-delete.color-danger.ip__btn
                  .add-ip__input(v-if="addingIp.user_name === scope.row.name")
                    el-input(size="mini" v-model="addingIp.ip")
                    el-button(icon="el-icon-check" circle size="mini" :disabled="!addingIp.ip" @click="addUserAllowedIp")
                  .add-ip__btn(v-else @click="openAddIp(scope.row.name, scope.row.allowed_ips)")
                    i.el-icon-plus
    el-dialog(:visible.sync="isUserAdding" :before-close="resetUserAdding" title="Добавление пользователя" width="50%")
      AddUser(v-if="isUserAdding" @resetUserAdd="resetUserAdding" @updateUsers="loadUsersList")
    el-dialog(:visible.sync="is2faOpened" :before-close="resetUser2fa" title="Двухфакторная аутентификация" width="50%")
      TwoFactor(v-if="is2faOpened" @resetUser2fa="resetUser2fa")
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  CREATE_USER,
  EDIT_USER,
  LOAD_USERS_LIST,
} from "@/store/const/user";
import AddUser from "./AddUser";
import TwoFactor from "./TwoFactor";
import instruments from '../../mixins/instruments';

export default {
  name: 'Users',
  components: {
    AddUser,
    TwoFactor,
  },
  mixins: [
    instruments,
  ],
  data() {
    return {
      isUserAdding: false,
      addingIp: {
        user_name: '',
        user_ips: [],
        ip: '',
      },
      is2faOpened: false,
    }
  },
  mounted() {
    this.loadUsersList();
  },
  computed: {
    ...mapGetters([
      'loading',
      'error',
    ]),
    ...mapGetters('user', [
      'users',
      'isAdmin',
      'roles',
    ]),
    isLoading() {
      return this.loading(LOAD_USERS_LIST) === 'loading';
    },
    isError() {
      return this.loading(LOAD_USERS_LIST) === 'error';
    },
    errorMessage() {
      return this.error(LOAD_USERS_LIST);
    },
  },
  methods: {
    ...mapActions('user', {
      loadUsersList: LOAD_USERS_LIST,
      addNewUser: CREATE_USER,
      editUser: EDIT_USER,
    }),
    openUserAdding() {
      this.isUserAdding = true;
    },
    resetUserAdding() {
      this.isUserAdding = false;
    },
    openUser2fa() {
      this.is2faOpened = true;
    },
    resetUser2fa() {
      this.is2faOpened = false;
    },
    async startEditUser(name, data, confirmMessage, methodOnSuccess) {
      this.$confirm(
        confirmMessage || 'Подтвердите изменение пользователя',
        'Изменение пользователя'
      ).then(async () => {
        const request = await this.editUser({ name, data });
        const successMethod = methodOnSuccess ? [methodOnSuccess, this.loadUsersList] : this.loadUsersList;
        await this.notifyRequestResult({
          request,
          successMessage: 'Пользователь успешно изменен',
          methodOnSuccess: successMethod,
        });
      }).catch(() => {
        this.$message.info('Изменение пользователя отменено');
      });
    },
    async changeUserActiveStatus(user) {
      await this.startEditUser(
        user.name,
        { active: !user.active },
        `Вы уверены, что хотите ${user.active ? 'деактивировать' : 'активировать'} пользователя?`
      );
    },
    openAddIp(name, ips) {
      this.addingIp.ip = '';
      this.addingIp.user_ips = ips;
      this.addingIp.user_name = name;
    },
    async addUserAllowedIp() {
      const isNewIpValid = this.validateIPAddress(this.addingIp.ip);
      if (!isNewIpValid) {
        return this.$message.warning('Введенный IP-адрес не валиден!');
      }
      if (this.addingIp.user_ips.includes(this.addingIp.ip)) {
        return this.$message.warning('Введенный IP-адрес уже добавлен в список');
      }
      await this.startEditUser(
        this.addingIp.user_name,
        { allowed_ips: [...this.addingIp.user_ips, this.addingIp.ip] },
        `Вы уверены, что добавить IP-адрес к разрешенным у пользователя?`,
        this.resetAddIp,
      );
    },
    resetAddIp() {
      this.addingIp.ip = '';
      this.addingIp.user_ips = [];
      this.addingIp.user_name = '';
    }
  }
};
</script>
<style scoped>
.users-control__block {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.user-add__btn {
    width: 160px;
}

.token__val {
    font-family: monospace;
    font-size: 11px;
    cursor: pointer;
}

.ip__btn {
    margin-left: 5px;
    cursor: pointer;
}

.allowed-ips__container {
    text-align: center;
}

.add-ip__input {
    display: flex;
}

 .add-ip__btn {
     display: flex;
     text-align: center;
     margin: auto;
     font-size: 10px;
     border: 1px solid #d1cece;
     width: 16px;
     height: 16px;
     justify-content: center;
     align-items: center;
     cursor: pointer;
 }

.user-active-change__btn {
    cursor: pointer;
}
</style>
